export default import.meta.ROLLDOWN_FILE_URL_zAsjW5EPMaNQHKhwLtuBvw